import { EmployeeSummaryDto } from './employee-summary-dto.model';
import { CompanyDto } from './company-dto.model';
import { ProjectDto } from './project-dto.model';
import { ThumbApplicationType,TransactionStatus,ThumbSource,ThumbApplicationFromType } from '../service-proxies';


export class ThumbApplicationDto implements IThumbApplicationDto {
    id!: number;
    employee!: EmployeeSummaryDto;
    thumbDate!: Date;
    thumbTime!: Date;
    thumbType!: ThumbApplicationType;
    thumbTypeName!: string | undefined;
    thumbStatus!: TransactionStatus;
    thumbSource!: ThumbSource;
    thumbStatusName!: string | undefined;
    thumbRemark!: string | undefined;
    longitude!: number | undefined;
    latitude!: number | undefined;
    thumbRequestDate!: Date;
    company!: CompanyDto;
    project!: ProjectDto;
    thumbApplicationFromType!: ThumbApplicationFromType;
    thumbApplicationFromTypeName!: string | undefined;

    constructor(data?: IThumbApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.thumbDate = _data["thumbDate"] ? new Date(_data["thumbDate"].toString()) : <any>undefined;
            this.thumbTime = _data["thumbTime"] ? new Date(_data["thumbTime"].toString()) : <any>undefined;
            this.thumbType = _data["thumbType"];
            this.thumbTypeName = _data["thumbTypeName"];
            this.thumbStatus = _data["thumbStatus"];
            this.thumbSource = _data["thumbSource"];
            this.thumbStatusName = _data["thumbStatusName"];
            this.thumbRemark = _data["thumbRemark"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.thumbRequestDate = _data["thumbRequestDate"] ? new Date(_data["thumbRequestDate"].toString()) : <any>undefined;
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.project = _data["project"] ? ProjectDto.fromJS(_data["project"]) : <any>undefined;
            this.thumbApplicationFromType = _data["thumbApplicationFromType"];
            this.thumbApplicationFromTypeName = _data["thumbApplicationFromTypeName"];
        }
    }

    static fromJS(data: any): ThumbApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThumbApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["thumbDate"] = this.thumbDate ? this.thumbDate.toISOString() : <any>undefined;
        data["thumbTime"] = this.thumbTime ? this.thumbTime.toISOString() : <any>undefined;
        data["thumbType"] = this.thumbType;
        data["thumbTypeName"] = this.thumbTypeName;
        data["thumbStatus"] = this.thumbStatus;
        data["thumbSource"] = this.thumbSource;
        data["thumbStatusName"] = this.thumbStatusName;
        data["thumbRemark"] = this.thumbRemark;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["thumbRequestDate"] = this.thumbRequestDate ? this.thumbRequestDate.toISOString() : <any>undefined;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["thumbApplicationFromType"] = this.thumbApplicationFromType;
        data["thumbApplicationFromTypeName"] = this.thumbApplicationFromTypeName;
        return data; 
    }
}

export interface IThumbApplicationDto {
    id: number;
    employee: EmployeeSummaryDto;
    thumbDate: Date;
    thumbTime: Date;
    thumbType: ThumbApplicationType;
    thumbTypeName: string | undefined;
    thumbStatus: TransactionStatus;
    thumbSource: ThumbSource;
    thumbStatusName: string | undefined;
    thumbRemark: string | undefined;
    longitude: number | undefined;
    latitude: number | undefined;
    thumbRequestDate: Date;
    company: CompanyDto;
    project: ProjectDto;
    thumbApplicationFromType: ThumbApplicationFromType;
    thumbApplicationFromTypeName: string | undefined;
}

